"use client";
import Lottie from "lottie-react";
import heartBeat from "../../animations/heart-beat.json";
import Image from "next/image";
import Link from "next/link";

const Footer = () => {
  return (
    <div className="md:w-4/5 md:m-auto flex flex-col items-start gap-4 md:flex-row-reverse md:justify-between md:items-end mt-6 p-3 text-sm text-muted-foreground">
      <div className="flex gap-1">
        <span>{"Jennyz est fait avec "}</span>
        <Lottie animationData={heartBeat} loop={true} className="w-5 h-5" />
        <span>{" à Angers"}</span>
      </div>

      <div className="text-sm">
        <span>
          {"Copyright © "}
          {new Date().getFullYear()}
          {" Jennyz"}
        </span>
      </div>

      <div className="space-y-2 md:space-y-4">
        <Link
          className="flex items-center gap-2"
          href="https://www.youtube.com/@Jennyz_co"
        >
          <Image
            src="/youtube-dark.svg"
            alt={"Youtube Icon Dark"}
            width={20}
            height={20}
            className="dark:hidden"
          />
          <Image
            src="/youtube-light.svg"
            alt={"Youtube Icon Light"}
            width={20}
            height={20}
            className="hidden dark:block"
          />
          <p>{"Chaine Youtube"}</p>
        </Link>

        <Link
          className="flex items-center gap-2"
          href="https://x.com/jennyz_co"
        >
          <Image
            src="/X-dark.svg"
            alt={"X Icon Dark"}
            width={20}
            height={20}
            className="dark:hidden"
          />
          <Image
            src="/X-light.svg"
            alt={"X Icon Light"}
            width={20}
            height={20}
            className="hidden dark:block"
          />
          <p>{"Compte X"}</p>
        </Link>

        <Link
          className="flex items-center gap-2"
          href="https://www.instagram.com/jennyz_co"
        >
          <Image
            src="/instagram-dark.svg"
            alt={"Instagram Icon Dark"}
            width={20}
            height={20}
            className="dark:hidden"
          />
          <Image
            src="/instagram-light.svg"
            alt={"Instagram Icon Light"}
            width={20}
            height={20}
            className="hidden dark:block"
          />
          <p>{"Instagram"}</p>
        </Link>
      </div>
    </div>
  );
};

export default Footer;
